import { useCommonStore } from '@shared/model'
import { PageType } from '@shared/config'

export default defineNuxtRouteMiddleware( async () => {
  const commonStore = useCommonStore()
  commonStore.setPageType(PageType.Ela)
})
